<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <div class="d-flex flex-row align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class="h5 font-weight-semibold">Detail Pengiriman</h3>
            <div class="d-flex flex-row align-items-center">
                <div class="d-flex flex-row align-items-center">
                    <div style="max-width: 200px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Semua Tahun"
                        ></MultiSelect>
                    </div>
                    <div style="max-width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Semua Bulan"
                        ></MultiSelect>
                    </div>
                    <div style="max-width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Malang"
                        ></MultiSelect>
                    </div>
                    <div style="max-width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Semua Karesidenan"
                        ></MultiSelect>
                    </div>
                    <div style="max-width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Semua Dealer"
                        ></MultiSelect>
                    </div>
                    <div style="max-width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Semua Kategori"
                        ></MultiSelect>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100">
                <thead>
                    <tr>
                        <th class="text-left border-top border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">Qty</th>
                        <th class="text-left border-top border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">Tanggal Pengiriman</th>
                        <th class="text-left border-top border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">Kode Dealer</th>
                        <th class="text-left border-top border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">Kode BAST</th>
                        <th class="text-left border-top border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">Tanggal BAST</th>
                        <th class="text-left border-top border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">Status</th>
                        <th class="text-left border-top border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">Kategori Terlambat</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dat in data">
                        <td class="text-left border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">{{ dat.qty }}</td>
                        <td class="text-left border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">{{ dat.delivery_date }}</td>
                        <td class="text-left border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">{{ dat.dealer_code }}</td>
                        <td class="text-left border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">{{ dat.bast_code }}</td>
                        <td class="text-left border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">{{ dat.bast_date }}</td>
                        <td class="text-left border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">{{ dat.status }}</td>
                        <td class="text-left border-bottom" style="padding: 8px 16px; border-color: #F3F3F3">
                            <span :style="late_category_dictionary[dat.late_category]" style="padding: 3px 10px; border-radius: 4px; font-weight: bold;">
                                {{ dat.late_category }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3">
            <p class="text-muted mb-0">Showing 1-5 of 7 items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">1</p>
                <button class="btn btn-link px-1" style="color: #627884"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                late_category_dictionary: {
                    "> 30 hari": {color: "#EC0000", background: "#FFE8E8"},
                    "14-30 hari": {color: "#C9880A", background: "#FFF2EA"},
                    "5-13 hari": {color: "#C6B731", background: "#FCFBE1"},
                    "< 5 hari": {color: "#00A86B", background: "#E8FFF2"},
                },
                data : [
                    {
                        qty: "1.000",
                        delivery_date: "01 Jan 2024 | 13:24",
                        dealer_code: "K0040",
                        bast_code: "BH59FSDEWL20K",
                        bast_date: "01 Jan 2024 | 13:24",
                        status: "In-Transit",
                        late_category: "> 30 hari"
                    },
                    {
                        qty: "1.500",
                        delivery_date: "12 Jan 2024 | 14:32",
                        dealer_code: "K0040",
                        bast_code: "-",
                        bast_date: "12 Jan 2024| 14:32",
                        status: "In-Transit",
                        late_category: "14-30 hari"
                    },
                    {
                        qty: "500",
                        delivery_date: "20 Jan 2024 | 16:49",
                        dealer_code: "K0040",
                        bast_code: "BH59FSDEWLO3N",
                        bast_date: "20 Jan 2024 | 16:49",
                        status: "In-Transit",
                        late_category: "5-13 hari"
                    },
                    {
                        qty: "500",
                        delivery_date: "05 Feb 2024 | 13:21",
                        dealer_code: "K0040",
                        bast_code: "-",
                        bast_date: "05 Feb 2024 | 13:21",
                        status: "In-Transit",
                        late_category: "> 30 hari"
                    },
                    {
                        qty: "1.000",
                        delivery_date: "10 Feb 2024 | 09:59",
                        dealer_code: "K0040",
                        bast_code: "-",
                        bast_date: "10 Feb 2024 | 09:59",
                        status: "In-Transit",
                        late_category: "14-30 hari"
                    },
                ],
                filter : {
                    year: null,
                    month: null
                }
            }
        }
    }
</script>